import PropTypes from "prop-types";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";

const ActionMenu = ({ label = "Actions", items = [] }) => {
  return (
    <Menu
      menuButton={
        <MenuButton className="btn btn-sm btn-outline-primary px-2">
          {label}
        </MenuButton>
      }
      portal
      viewScroll="auto"
      position="anchor"
      align="end"
      direction="bottom"
      menuClassName="shadow"
    >
      {items.map((item) => (
        <MenuItem
          key={item.key}
          onClick={() => {
            item.onClick?.();
          }}
          disabled={item.disabled}
        >
          {item.label}
        </MenuItem>
      ))}
    </Menu>
  );
};

ActionMenu.propTypes = {
  label: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      disabled: PropTypes.bool,
    })
  ),
};

export default ActionMenu;
